import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getFlagUrl } from './Utils/getFlagUrl';
import SprintQualificationMobile from "./SprintQualificationMobile";
import SprintBattlesMobile from "./SprintBattlesMobile";
import SprintSeriesMobile from "./SprintSeriesMobile";
import KeirinMobile from "./KeirinMobile";
import OmniumMobile from "./OmniumMobile";
import OmniumRacesMobile from "./OmniumRacesMobile";
import MadisonMobile from "./MadisonMobile";
import ScratchEliminationPointsMobile from "./ScratchEliminationPointsMobile";
import EnduranceQualificationMobile from "./EnduranceQualificationMobile";

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
console.log("✅ API Key in build:", API_KEY);

const isSprint = (name) => name.toLowerCase().includes("sprint");
const isQualification = (name) =>
  name.toLowerCase().includes("qualification") || name.toLowerCase().includes("qualifying");



const isBattle = (name) =>
  isSprint(name) && ["1/16 finals", "1/8 finals"].some(stage => name.toLowerCase().includes(stage));
const isAdvancedBattle = (name) =>
  isSprint(name) && ["1/4 finals", "semifinals", "finals"].some(stage => name.toLowerCase().includes(stage));
const isKeirin = (name) => name.toLowerCase().includes("keirin");

const DisciplineLive = () => {
  const { eventName, disciplineName } = useParams();
  const navigate = useNavigate();

  const [eventData, setEventData] = useState(null);
  const [eventDisplayName, setEventDisplayName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [data, setData] = useState([]);
  const [googleSheetsId, setGoogleSheetsId] = useState("");
  const [sheetName, setSheetName] = useState("");
  const [rowRange, setRowRange] = useState([0, 0]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [relatedEvents, setRelatedEvents] = useState([]);
  const [boldRows, setBoldRows] = useState([]);

  const omniumDisciplines = ["Omnium ME", "Omnium WE", "Omnium MU19", "Omnium WU19", "Omnium MJ", "Omnium WJ"];
  const madisonDisciplines = ["Madison ME", "Madison WE", "Madison MJ", "Madison WJ"];
  const isOmnium = omniumDisciplines.includes(displayName);
  const isMadison = madisonDisciplines.includes(sheetName);

  useEffect(() => {
    fetch(`/api/events/${eventName}`)
      .then((response) => response.json())
      .then((jsonData) => {
        setEventData(jsonData);
        setEventDisplayName(jsonData.name);
        setGoogleSheetsId(jsonData.googleSheetsId);

        const discipline = jsonData.disciplines
          .flatMap((day) => day.events)
          .find((d) => d.name.replace(/\s+/g, "-").replace(/\//g, "-").toLowerCase() === disciplineName);

        if (discipline) {
          setSheetName(discipline.sheetName);
          setRowRange(discipline.rowRange);
          setSelectedColumns(discipline.columns);
          setRelatedEvents(discipline.relatedEvents || []);
          setDisplayName(discipline.displayName || discipline.name);
          setBoldRows(discipline.boldRows || []);
        }
      })
      .catch((error) => console.error("❌ Error loading event JSON:", error));
  }, [eventName, disciplineName]);

  useEffect(() => {
    const fetchData = () => {
      fetch(`/api/sheets/${eventName}/${disciplineName}`)
        .then((response) => response.json())
        .then((jsonData) => {
          console.log('✅ Google Sheets Data (interval):', jsonData);
          setData(jsonData.values || []);
        })
        .catch((error) => console.error("❌ Error loading Google Sheets data:", error));
    };
  
    fetchData(); // první fetch hned při načtení
  
    const interval = setInterval(fetchData, 10000); // opakování každých 10 vteřin
  
    return () => clearInterval(interval); // zruš interval při unmountu
  }, [eventName, disciplineName]);
  

  let currentHeaderRow = [];
  const isOmniumSubDiscipline = displayName.toLowerCase().includes("omnium") &&
    (displayName.toLowerCase().includes("scratch") ||
     displayName.toLowerCase().includes("tempo") ||
     displayName.toLowerCase().includes("elimination") ||
     displayName.toLowerCase().includes("points"));

     const isSprintGrandFinals = /^sprint (me|we|mj|wj) finals$/i.test(displayName.trim());

    
    



  return (
    <div className="p-4 discipline-container">
      <button onClick={() => navigate(`/event/${eventName}`)} className="back-button">
        ⬅️ Back to {eventDisplayName || eventName.replace(/-/g, " ")}
      </button>

      <h1 className="discipline-title">{displayName}</h1>
      <h3 className="discipline-subtitle">Results</h3>

      {relatedEvents.length > 0 && (
        <div className="related-events">
          {relatedEvents.map((relatedEvent, index) => {
            const formattedRelatedEvent = relatedEvent.replace(/\s+/g, "-").replace(/\//g, "-").toLowerCase();
            return (
              <button key={index} className="event-switch-button" onClick={() => navigate(`/event/${eventName}/discipline/${formattedRelatedEvent}`)}>
                {relatedEvent}
              </button>
            );
          })}
        </div>
      )}

      {data.length > 0 ? (
        <>
        <table className={`discipline-table desktop-only ${isOmnium ? "omnium-table" : ""}`}>
          <tbody>
            {isOmnium && (
              <tr className="omnium-second-header">
                <td colSpan={5}></td>
                <td colSpan={2}>Scratch</td>
                <td colSpan={2}>Tempo Race</td>
                <td colSpan={2}>Elimination</td>
                <td>Points Race</td>
                <td></td>
              </tr>
            )}
            {data.map((row, i) => {
              const rowNumber = rowRange[0] + i + 1;
              const isBold = boldRows.includes(rowNumber);
              const isPairEnd = isMadison && (i >= 1) && ((i - 1) % 2 === 1);
              const isSpacerRow = row.every(cell => (cell || "").trim() === "");

              if (isSpacerRow) return <tr key={`spacer-${i}`} className="spacer-row"><td colSpan={selectedColumns.length}></td></tr>;

              const hasFinal = row.some(cell => typeof cell === "string" && cell.trim().toLowerCase().includes("final"));
              const hasRepechage = row.some(cell => typeof cell === "string" && cell.trim().toLowerCase().includes("repechage"));
              const heatPattern = /^(heat (1|2|3|4|5|6))$/i;
              const hasExactHeat = row.some(cell => typeof cell === "string" && heatPattern.test(cell.trim()));

              const isFinalHeader = row.some(cell => typeof cell === "string" && cell.toLowerCase().includes("final"));

              if (isSprintGrandFinals && isFinalHeader) {
                return (
                  <tr key={`final-${i}`} className="final-header-row">
                    <td colSpan={selectedColumns.length} className="final-header-cell">
                      {row[0].trim().toUpperCase()}
                    </td>
                  </tr>
                );
              }
              
              
              

              const isHeaderRow = row.some(cell => typeof cell === "string" && (cell.trim().toLowerCase() === "rnk" || cell.trim().toLowerCase() === "bib"));
if (isHeaderRow) {
  currentHeaderRow = row;
  return (
    <tr key={`header-${i}`} className="header-row">
      {row.map((cell, j) => {
        const isLastCol = j === row.length - 1;
        if (isQualification(displayName) && isLastCol) return null;
        return <th key={j}>{cell}</th>;
      })}
    </tr>
  );
}
const rowAsText = row.map(c => (c || "").toLowerCase()).join(" ");
if (
  !isSprintGrandFinals &&
  (rowAsText.includes("final for gold") || rowAsText.includes("final for bronze"))
) {
  return null;
}


              return (
                <React.Fragment key={i}>
                  <tr className={`${isBold ? "bold-row" : ""}${isPairEnd ? "madison-pair-border" : ""}`}>
                    {row.map((cell, j) => {
                      const headerCell = currentHeaderRow[j];
                      const isCountryCol = headerCell && ["country", "nat", "nationality"].includes(headerCell.trim().toLowerCase());
                      const isWinner = typeof cell === "string" && cell.toLowerCase().includes("winner");
                      if (isQualification(displayName) && j === row.length - 1) {
                        return (
                          <td key={j} className="qualified-cell">
  {cell === "Q" && <span className="qualified-badge">Q</span>}
</td>

                        );
                      }
                      
                      return isCountryCol ? (
                        <td key={j}><img src={getFlagUrl(cell)} alt={cell} className="flag-icon" /></td>
                      ) : (
                        <td key={j} className={isWinner ? "winner-cell" : ""}>{cell}</td>
                      );
                      
                    })}
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>

        <div className="mobile-only">
          {displayName.toLowerCase().startsWith("omnium") &&
            !isOmniumSubDiscipline &&
            !displayName.toLowerCase().includes("qualifying") && (
            <OmniumMobile data={data} boldRows={boldRows} rowRange={rowRange} />
          )}

          {isSprint(displayName) && isQualification(displayName) && (
            <SprintQualificationMobile data={data} boldRows={boldRows} rowRange={rowRange} />
          )}
          {isSprint(displayName) && isBattle(displayName) && (
            <SprintBattlesMobile data={data} boldRows={boldRows} rowRange={rowRange} />
          )}
          {isSprint(displayName) && isAdvancedBattle(displayName) && (
            <SprintSeriesMobile
              data={data}
              boldRows={boldRows}
              rowRange={rowRange}
              discipline={displayName}
            />
          )}
          {isKeirin(displayName) && (
            <KeirinMobile
              data={data}
              boldRows={boldRows}
              rowRange={rowRange}
              discipline={displayName}
            />
          )}

          {isOmniumSubDiscipline && (
            <OmniumRacesMobile
              data={data}
              boldRows={boldRows}
              rowRange={rowRange}
              discipline={displayName.toLowerCase().includes("scratch") ? "scratch" :
                          displayName.toLowerCase().includes("tempo") ? "tempo" :
                          displayName.toLowerCase().includes("elimination") ? "elimination" : "points"}
            />
          )}

          {isMadison && (
            <MadisonMobile data={data} boldRows={boldRows} rowRange={rowRange} discipline={displayName} />
          )}

          {!displayName.toLowerCase().includes("qualifying") &&
            !isOmniumSubDiscipline &&
            ["scratch", "elimination", "points race"].some((d) => displayName.toLowerCase().includes(d)) && (
              <ScratchEliminationPointsMobile
                data={data}
                boldRows={boldRows}
                rowRange={rowRange}
                discipline={displayName}
              />
          )}

          {displayName.toLowerCase().includes("qualifying") && (
            <EnduranceQualificationMobile
              data={data}
              boldRows={boldRows}
              rowRange={rowRange}
              discipline={displayName}
            />
          )}
        </div>
        </>
      ) : <p className="no-data">⚠️ Žádná data k zobrazení.</p>}
    </div>
  );
};

export default DisciplineLive;
